import { Component, OnInit } from '@angular/core';

import { ChartInfo } from '../../../models/common/chartInfo';

@Component({
  standalone: false,
  selector: 'bt-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.scss']
})
export class ManagementComponent implements OnInit {

  public catalogChart: ChartInfo;

  constructor() { }

  ngOnInit() {
    this.catalogChart = new ChartInfo({
      type: 'line',
      data: {
        labels: ['1', '2', '3', '1', '2', '3', '1', '2', '3', '1', '2', '3', '1', '2', '3'],
        datasets: [{
          data: [12, 13, 40, 45, 46, 40, 76, 34, 40, 44, 31, 40, 50, 13, 40],
          backgroundColor: 'rgba(69, 90, 100, .5)',
          borderColor: 'rgba(69, 90, 100, 0.2)',
          borderWidth: 1,
          fill: true,
          tension: 0.4,
          pointBackgroundColor: 'rgba(69, 90, 100, 0.2)',
          pointBorderColor: 'rgba(69, 90, 100, 0.2)',
        }]
      },
      options: { responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false } } },
    });
  }
}
